import { defaultAuthenticationSettings } from '../data/mockData';
import type { AuthenticationSettings } from '../types';

/** Deep-merge partial auth settings onto defaults so nested arrays (fields) are never lost. */
export function mergeAuthenticationSettings(
  source?: Partial<AuthenticationSettings> | null,
): AuthenticationSettings {
  const base = defaultAuthenticationSettings;
  if (!source) return { ...base };

  return {
    ...base,
    ...source,
    id: source.id ?? base.id,
    adminAuth: {
      ...base.adminAuth,
      ...(source.adminAuth || {}),
      fields:
        Array.isArray(source.adminAuth?.fields) && source.adminAuth.fields.length > 0
          ? source.adminAuth.fields
          : base.adminAuth.fields,
    },
    userAuth: {
      signIn: {
        ...base.userAuth.signIn,
        ...(source.userAuth?.signIn || {}),
        fields:
          Array.isArray(source.userAuth?.signIn?.fields) &&
          source.userAuth.signIn.fields.length > 0
            ? source.userAuth.signIn.fields
            : base.userAuth.signIn.fields,
      },
      signUp: {
        ...base.userAuth.signUp,
        ...(source.userAuth?.signUp || {}),
        usernameField: {
          ...base.userAuth.signUp.usernameField,
          ...(source.userAuth?.signUp?.usernameField || {}),
        },
        fields:
          Array.isArray(source.userAuth?.signUp?.fields) &&
          source.userAuth.signUp.fields.length > 0
            ? source.userAuth.signUp.fields
            : base.userAuth.signUp.fields,
      },
    },
    templateSelection: {
      ...base.templateSelection,
      ...(source.templateSelection || {}),
    },
    createdAt: source.createdAt ?? base.createdAt,
    updatedAt: source.updatedAt ?? base.updatedAt,
  };
}
